
import { i18n } from '@/app/vuewidget'
import { fwgpricecent } from '@/helpers/FilterFwg'

const chfLabelFn = ({percent}, {totalWithoutSurcharges}) => fwgpricecent(Math.round((totalWithoutSurcharges / 100 * percent) / 5) * 5, 'html');
const percentLabelFn = ({percent}) => `${percent}%`;

export default [
	// 0: default (old) variant
	{
		variant: 0,
		subVariants: [
			{
				variant: 0,
				options: [
					{
						type: 'none',
						labelKey: 'checkout.tipOptions.none',
						default: true,
						value: 0,
					},
					{
						type: 'auto',
						labelKey: 'checkout.tipOptions.auto',
					},
					{
						type: 'percent',
						labelKey: 'checkout.tipOptions.percent',
						percent: 0,
						range: {
							min: 0,
							max: 30,
							step: 1,
						}
					},
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 50,
						}
					},
				]
			}
		]
	},
	// 1: variant with 3 percentage values and a custom chf option
	{
		variant: 1,
		subVariants: [
			{
				variant: 0,
				options: [
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 5
					},
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 10
					},
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 15
					},
					{
						type: 'none',
						labelKey: 'checkout.tipOptions.none',
						// default: true,
						value: 0,
					},
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 5,
						}
					},
				]
			},
			{
				variant: 1,
				options: [
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 7
					},
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 10
					},
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 15
					},
					{
						type: 'none',
						labelKey: 'checkout.tipOptions.none',
						// default: true,
						value: 0,
					},
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 5,
						}
					},
				]
			},
			{
				variant: 2,
				options: [
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 7
					},
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 10
					},
					{
						type: 'percent',
						labelFn: percentLabelFn,
						percent: 18
					},
					{
						type: 'none',
						labelKey: 'checkout.tipOptions.none',
						// default: true,
						value: 0,
					},
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 5,
						}
					},
				]
			}
		]
	},
	// 2: variant with 3 chf values and a custom chf option
	{
		variant: 2,
		subVariants: [
			{
				variant: 0,
				options: [
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 5
					},
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 10
					},
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 15
					},
					{
						type: 'none',
						labelKey: 'checkout.tipOptions.none',
						// default: true,
						value: 0,
					},
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 5,
						}
					},
				]
			},
			{
				variant: 1,
				options: [
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 7
					},
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 10
					},
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 15
					},
					{
						type: 'none',
						labelKey: 'checkout.tipOptions.none',
						// default: true,
						value: 0,
					},
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 5,
						}
					},
				]
			},
			{
				variant: 2,
				options: [
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 7
					},
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 10
					},
					{
						type: 'chf',
						labelFn: chfLabelFn,
						percent: 18
					},
					{
						type: 'none',
						labelKey: 'checkout.tipOptions.none',
						// default: true,
						value: 0,
					},
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 5,
						}
					},
				]
			}
		]
	},
	// 3: variant with only the custom chf option
	{
		variant: 3,
		subVariants: [
			{
				variant: 0,
				options: [
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						default: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 5,
						}
					},
				]
			},
			{
				variant: 1,
        titleKey: 'checkout.tipTitleAdd',
        hintKey: 'checkout.tipHintAdd',
				options: [
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
						fallback: true,
						default: true,
						value: 0,
						range: {
							min: 0,
							max: 5000,
							step: 5,
						},
						modifier: (option, { total }) => fwgpricecent(total, 'html')
					},
				]
			},
		]
	}
]
